import { getAllProductApi } from "../../apis/product.api";
import { actions } from "../../utils/constants/main";
import { callApiAction } from "./commonAction";

export const fetchProductAction = (
  data,
  onSuccess = () => {},
  onError = () => {}
) => {
  return async (dispatch, getState) => {
    dispatch({ type: actions.START_PRODUCT_LOADING });
    dispatch(
      callApiAction(
        async () => await getAllProductApi(data),
        (response) => {
          dispatch({ type: actions.SET_PRODUCT_DATA, data: response });
          onSuccess(response);
        },
        (err) => {
          dispatch({ type: actions.CLEAR_PRODUCT_DATA });
          onError(err);
        }
      )
    );
  };
};
export const addProductData = (newDoc) => {
  return { type: actions.ADD_PRODUCT_DATA, data: newDoc };
};
export const clearProductData = (newDoc) => {
  return { type: actions.CLEAR_PRODUCT_DATA };
};
